import { render } from "./Materiali.vue?vue&type=template&id=06485d6d&scoped=true&ts=true"
import script from "./Materiali.vue?vue&type=script&lang=ts"
export * from "./Materiali.vue?vue&type=script&lang=ts"

import "./Materiali.vue?vue&type=style&index=0&id=06485d6d&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_puma/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06485d6d"]])

export default __exports__